import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../store/services/user.service';
import { IUserSessionData } from '../../../store/models/user.model';
import { UtilitiesService } from '../../../store/services/utilities.servive';
import { ISelectItem } from '../../../store/models/select.model';
import { TagsService } from '../../../store/services/tags.service';
import { ITag } from '../../../cos/tags.model';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog } from 'app/store/actions/page.action';
import { faQuestionCircle, IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-edit-account',
  templateUrl: './edit-account.component.html',
  styleUrls: ['./edit-account.component.scss'],
})
export class EditAccountComponent implements OnInit {
  iconQuestionCircle: IconDefinition = faQuestionCircle;
  duplicateTooltip: string = `<p>If the Check Duplicate is disabled, subordinate users under same manager can have same contact email addresses freely. <br/> If Check Duplicate is enabled -> User cannot create contact if the email address is already created as a contact of a subordinate user under same manager. Inbound messages from the email address will still route. Red no match can be created but will go directly to No Campaign group. This email will be flagged as duplicate. Reply actions can be performed. But the contact cannot be sent to any Campaign</p>`;

  inputForm: FormGroup;

  accountId: number;

  componentReady = false;
  states: ISelectItem[] = [];
  countries: ISelectItem[];
  tags: ITag[] = [];

  accountData: IUserSessionData;


  constructor(
    private readonly userService: UserService,
    private readonly utilService: UtilitiesService,
    private readonly tagsService: TagsService,
    private readonly store: Store<IReducers>,
  ) {
  }

  get tagItems(): ISelectItem[] {
    return this.tags.map(t => ({
      label: t.name,
      value: t.name,
    }));
  }

  ngOnInit(): void {
    this.tagsService.getTags().subscribe(tags => this.tags = tags.items);
    if (this.accountId) {
      this.userService
        .getAccountInf(this.accountId)
        .subscribe((result: IUserSessionData) => {
          if (result) {
            this.accountData = result;
            this.inputForm.addControl(
              'email',
              new FormControl(result.email, [
                Validators.required,
                Validators.email,
              ]),
            );
            this.inputForm.addControl(
              'first_name',
              new FormControl(result.first_name, [Validators.required]),
            );
            this.inputForm.addControl(
              'last_name',
              new FormControl(result.last_name, []),
            );
            this.inputForm.addControl(
              'company',
              new FormControl(result.company, []),
            );
            this.inputForm.addControl(
              'address1',
              new FormControl(result.address1, [Validators.required]),
            );
            this.inputForm.addControl(
              'address2',
              new FormControl(result.address2, []),
            );
            this.inputForm.addControl('city', new FormControl(result.city, []));
            this.inputForm.addControl('zip', new FormControl(result.zip, []));
            this.inputForm.addControl(
              'phone_number',
              new FormControl(result.phone_number, []),
            );
            this.inputForm.addControl('state', new FormControl(result.state, [Validators.required]));
            this.inputForm.addControl('country', new FormControl(result.country, Validators.required));
            this.countries = Object.keys(this.utilService.getCountries()).map(
              country => {
                return {
                  label: this.utilService.getCountries()[country],
                  value: country,
                };
              },
            );
            this.inputForm.addControl('cos', new FormControl(result.cos, []));
            this.inputForm.addControl('franchis_number', new FormControl(result.franchis_number, []));
            this.inputForm.addControl('account_note', new FormControl(result.account_note, []));
            this.inputForm.addControl('invoice_note', new FormControl(result.invoice_note, []));
            this.inputForm.addControl('optional_note_1', new FormControl(result.optional_note_1, []));
            this.inputForm.addControl('optional_note_2', new FormControl(result.optional_note_2, []));
            this.inputForm.addControl('check_duplicate', new FormControl(result.check_duplicate, []));
            this.onCountrySelect(result.country);
            this.componentReady = true;
          }
        });
    }
  }

  onCountrySelect(value: string) {
    const states = this.utilService.getStates();

    if (states[value]) {
      this.states = Object.keys(states[value]).map(state => {
        return {
          label: states[value][state],
          value: state,
        };
      });
    }
  }
}
